function SectionCandidateAbout1() {
    return (
        <>
            <h4 className="twm-s-title">About Me</h4>
            <p>I am a passionate Physics educator holding a Master’s degree in Physics and more than six years of experience teaching grades 9–12. My expertise spans classical mechanics, electromagnetism, thermodynamics, and modern physics, which I bring to life through engaging lectures and hands-on laboratory experiments. </p>
            <p>I believe that interactive demonstrations—such as building simple circuits or conducting motion experiments—help students grasp abstract concepts more readily and develop a genuine curiosity for the natural world.</p>
        </>
    )
}

export default SectionCandidateAbout1;